import { render, staticRenderFns } from "./ShiftFields.vue?vue&type=template&id=be164eea"
import script from "./ShiftFields.vue?vue&type=script&lang=js"
export * from "./ShiftFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports